import API from "api/API";
import useFetchData from "hooks/useFetchData";

export default function useUDCompareGroups( name1, name2 ) {
   return useFetchData({
      APIMethod: API.getUDCompareGroups,
      condition: !!name1 && !!name2,
      cache_name: `${name1}-${name2}-ud-compare-groups`,
      params: [ name1, name2 ],
      resultDataHandler: data => {
         // API zwraca tablicę obiektów z edition1 i edition2
         // Musimy zmapować to do formatu używanego w aplikacji
         return data.map( item => {
            // Używamy danych z edition1 jako podstawy, ale musimy zachować informację o obu edycjach
            const edition1Var = item.edition1;
            return {
               value: edition1Var.id,
               label: edition1Var.name,
               table_header: edition1Var.table_header || null,
               edition1_id: edition1Var.id,
               edition2_id: item.edition2.id
            };
         });
      }
   })
}
